/**
 * QL-741 — portfolio_display's own settings: a pie chart of the products,
 * the products table, and the portfolio name under them. Shared by the add
 * and the settings dialog.
 */

import { pickT } from "@repo/shared";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { T } from "./settings-portfolio-display-form.i18n";

type SettingsPortfolioDisplayFormProps = {
  flowLanguage: string;
  showChart: boolean;
  onShowChartChange: (show: boolean) => void;
  showTable: boolean;
  onShowTableChange: (show: boolean) => void;
  showPortfolioName: boolean;
  onShowPortfolioNameChange: (show: boolean) => void;
};

export function SettingsPortfolioDisplayForm({
  flowLanguage,
  showChart,
  onShowChartChange,
  showTable,
  onShowTableChange,
  showPortfolioName,
  onShowPortfolioNameChange,
}: SettingsPortfolioDisplayFormProps) {
  const t = pickT(T, flowLanguage);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <Label htmlFor="portfolio-display-show-chart" className="text-base">
          {t.showChart}
        </Label>
        <Switch
          id="portfolio-display-show-chart"
          checked={showChart}
          onCheckedChange={onShowChartChange}
        />
      </div>

      <div className="flex items-center justify-between">
        <Label htmlFor="portfolio-display-show-table" className="text-base">
          {t.showTable}
        </Label>
        <Switch
          id="portfolio-display-show-table"
          checked={showTable}
          onCheckedChange={onShowTableChange}
        />
      </div>

      {!showChart && !showTable && (
        <div className="text-sm text-destructive bg-destructive/10 p-3 rounded-md">
          {t.atLeastOneOption}
        </div>
      )}

      <div className="flex items-center justify-between">
        <Label htmlFor="portfolio-display-show-name" className="text-base">
          {t.showPortfolioName}
        </Label>
        <Switch
          id="portfolio-display-show-name"
          checked={showPortfolioName}
          onCheckedChange={onShowPortfolioNameChange}
        />
      </div>
    </div>
  );
}
